module.exports = __webpack_public_path__ + "static/GT-Super-Display-Medium-350b155504922a7a8d2dce19caa4da0b.woff2";